<div class="row-wrap bg-white">
  <div class="wrap-content" *ngIf="news">
    <span class="datetime"> {{ news?.date | date : "mediumDate" }} </span>
    <a href="{{ news?.url }}" target="_blank" class="text-detail">
      <span>{{ news?.title }} </span>
    </a>
  </div>
</div>
